import React, { useState } from "react";
import MidwestDentalProgressTracker from "../../components/progressTracker/MidwestDentalProgressTracker";

const locationUrls = {
  Skokie: "https://healow.com/apps/provider/-asstsk-2418213",
  Chicago: "https://healow.com/apps/provider/-asstch-2418210",
  Lombard: "https://healow.com/apps/provider/-asstob-2418212",
  HomerGlen: "https://healow.com/apps/provider/-assthg-2418211",
  SBarrington: "https://healow.com/apps/provider/-baasst-3424977",
};
const defaultUrl =
  "https://healow.com/apps/practice/midwest-dental-sleep-center-785?v=2&t=2&vr=XGx7DvPXY1yvd0lb";

const MidwestDentalThankYouScreen = ({
  steps,
  deviceType,
  configs,
  firstName,
  location,
  contactPhone,
  contactEmail,
  onSchedule,
  onBack,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const displayName = firstName || "";
  const displayPhone = contactPhone || "[Phone Number]";
  const displayEmail = contactEmail || "[Email Address]";

  const getScheduleUrl = () => {
    if (!location) return defaultUrl;
    return locationUrls[location] || defaultUrl;
  };

  const handleScheduleClick = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      if (onSchedule) {
        onSchedule();
        setTimeout(() => {
          window.open(getScheduleUrl(), "_self");
        }, 500);
      }
    } catch (err) {
      console.error("Error submitting journey:", err);
    }
    setSubmitting(false);
  };
  return (
    <div className="midwest-dental-form-layout">
      {/* Fixed Header with Progress Tracker */}
      <div className="midwest-dental-fixed-header">
        <MidwestDentalProgressTracker
          steps={steps}
          currentStep={steps?.length || 3}
          deviceType={deviceType}
        />
      </div>

      {/* Scrollable Content */}
      <div className="midwest-dental-content-area">
        <div className="midwest-dental-thankyou-card">
          {configs?.logo && (
            <div className="midwest-dental-thankyou-logo-container">
              <img
                src={configs.logo}
                alt="Logo"
                className="midwest-dental-thankyou-logo"
              />
            </div>
          )}

          <div className="midwest-dental-thankyou-content">
            <h2 className="midwest-dental-thankyou-title">
              Thank you{displayName ? `, ${displayName}` : ""}!
            </h2>
            <p className="midwest-dental-thankyou-subtitle">
              Based on your responses, you're ready to schedule your consultation
            </p>
          </div>

          <div className="midwest-dental-thankyou-button-section">
            <button
              onClick={handleScheduleClick}
              disabled={submitting}
              className="midwest-dental-schedule-btn"
            >
              {submitting ? "Submitting..." : "Click here to schedule appointment"}
            </button>
          </div>

          <div className="midwest-dental-thankyou-footer">
            <p className="midwest-dental-thankyou-contact">
              If you have any questions before your visit, don't hesitate to reach out to us at {displayPhone} or {displayEmail}.
            </p>
          </div>
        </div>
      </div>

      {/* Fixed Footer explicitly placed outside the card to match Entry and Disclaimer page styling */}
      <div className="bottom-bar-shadow">
        <div className="flex justify-between pt-3 m-auto bottom-bar w-full">
          <button className="text_button" onClick={onBack}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 12H5M5 12L12 19M5 12L12 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Previous</span>
          </button>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default MidwestDentalThankYouScreen;
